import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { filter, map, mergeMap } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(private _router: Router, private titleService: Title, private activatedRoute: ActivatedRoute) { }

    ngOnInit(): void {

        this.overrideDateToJsonFunction();
        // Dynamic Page title : https://ultimatecourses.com/blog/dynamic-page-titles-angular-2-router-events
        this._router.events.pipe(filter((event) => event instanceof NavigationEnd))
            .pipe(map(() => this.activatedRoute),
                map((route) => {
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                }),
                filter((route) => route.outlet === 'primary'),
                mergeMap((route) => route.data))
            .subscribe((event) => {
                let webName = " | Marketplace";
                if (event.title == "Dealpos x Marketplace") {
                    webName = ""
                }
                this.titleService.setTitle(event['title'] + webName);
            });
    }

    private overrideDateToJsonFunction(): void {
        //Date json serialization override
        Date.prototype.toJSON = function () {
            let v = this.getFullYear() +
                '-' + pad(this.getMonth() + 1) +
                '-' + pad(this.getDate()) +
                'T' + pad(this.getHours()) +
                ':' + pad(this.getMinutes()) +
                ':' + pad(this.getSeconds()) +
                '.' + '000';
            return v
        }

        function pad(number) {
            if (number < 10) {
                return '0' + number;
            }
            return number;
        }
    }

}
